export const analiticaRoutes = [
  {
    path: '/analitica',
    name: 'Analiticas',
    component: () =>
      import(
        /* webpackChunkName: "analitica" */ '@/modules/Core/views/Index.vue'
      ),
    icon: 'mdiChartBar',
    typeIcon: 'mdi',
    menu: true,
    desplegable: true,
    meta: {
      title: 'Analíticas',
      requiresSession: true,
      perfiles: ['SUPERADMIN', 'CONTRATACION', 'ADMINISTRACION', 'DEMANDA INDUCIDA'],
      permiso: []
    },
    children: [
      {
        path: '/analitica/metas',
        name: 'AnaliticsMetas',
        component: () =>
          import(
            /* webpackChunkName: "analitica" */ '@/modules/Analitica/views/Metas/MetasCumplimientoIndex.vue'
          ),
        icon: 'mdiBullseyeArrow',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Actividades',
          subTitle: 'Cumplimiento de actividades por contrato',
          requiresSession: true,
          permiso: [],
          perfiles: ['SUPERADMIN', 'CONTRATACION', 'ADMINISTRACION', 'DEMANDA INDUCIDA'],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/analitica/oportunidades',
        name: 'AnaliticsOportunidades',
        component: () =>
          import(
            /* webpackChunkName: "analitica" */ '@/modules/Analitica/views/Oportunidades/OportunidadesIndex.vue'
          ),
        icon: 'mdiAccountSearchOutline',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Oportunidades',
          subTitle: 'Pacientes que aplican a un servicio del contrato',
          requiresSession: true,
          permiso: [],
          perfiles: ['SUPERADMIN', 'CONTRATACION', 'ADMINISTRACION', 'DEMANDA INDUCIDA'],
          showBackButton: true
        },
        children: []
      },
      {
        path: '/analitica/logs-eventos',
        name: 'AnaliticsLogsEventos',
        component: () =>
          import(
            /* webpackChunkName: "analitica" */ '@/modules/Analitica/views/LogsEventos.vue'
          ),
        icon: 'mdiTimelineClockOutline',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Logs de eventos',
          subTitle: 'Visualización de eventos del sistema',
          requiresSession: true,
          permiso: [],
          perfiles: ['SUPERADMIN'],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/analitica/consumo',
        name: 'AnaliticsConsumo',
        component: () =>
          import(
            /* webpackChunkName: "analitica" */ '@/modules/Analitica/views/Consumo/ConsumoIndex.vue'
          ),
        icon: 'mdiChartBoxOutline',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Consumo',
          subTitle: 'Consumo del plan asignado',
          requiresSession: true,
          permiso: [],
          perfiles: ['SUPERADMIN'],
          showBackButton: false
        },
        children: []
      }
    ]
  }
]
